(function () {
	let initFrame = null;

	const SWIPE_THRESHOLD = 40;

	const getSections = () => {
		return document.querySelectorAll('.main-product-section');
	};

	const getMainSliders = (section) => {
		return section.querySelectorAll(
			'.product__media-list[data-slider-type="main-product"]'
		);
	};

	const getMediaWrapper = (slider) => {
		return slider.closest('.product__media-wrapper');
	};

	const getSubSlider = (slider) => {
		const wrapper = getMediaWrapper(slider);

		if (!wrapper) return null;

		return wrapper.querySelector(
			'.product__media-sublist[data-slider-type="sub-product"]'
		);
	};

	const getRealSlides = (slider) => {
		return Array.from(
			slider.querySelectorAll(
				'.swiper-wrapper > .product__media-item.swiper-slide:not(.swiper-slide-duplicate)'
			)
		);
	};

	const getSlideCount = (slider) => {
		return Math.max(1, getRealSlides(slider).length);
	};

	const getRealIndex = (slider) => {
		const swiper = slider.swiper;
		const count = getSlideCount(slider);

		if (!swiper || swiper.destroyed) return 0;

		const rawIndex =
			typeof swiper.realIndex === 'number'
				? swiper.realIndex
				: typeof swiper.activeIndex === 'number'
					? swiper.activeIndex
					: 0;

		return ((rawIndex % count) + count) % count;
	};

	const ensureProgress = (slider) => {
		let progress = slider.querySelector('.main-product-hover-progress');
		const count = getSlideCount(slider);

		if (!progress) {
			progress = document.createElement('div');
			progress.className = 'main-product-hover-progress';
			progress.setAttribute('aria-hidden', 'true');
			slider.appendChild(progress);
		}

		const segments = progress.querySelectorAll(
			'.main-product-hover-progress__segment'
		);

		if (segments.length !== count) {
			progress.innerHTML = '';

			for (let i = 0; i < count; i += 1) {
				const segment = document.createElement('span');
				segment.className = 'main-product-hover-progress__segment';

				if (i === 0) {
					segment.classList.add('is-active');
				}

				progress.appendChild(segment);
			}
		}

		return progress;
	};

	const setProgress = (slider, index) => {
		const count = getSlideCount(slider);
		const safeIndex = ((index % count) + count) % count;
		const segments = slider.querySelectorAll(
			'.main-product-hover-progress__segment'
		);

		segments.forEach((segment, segmentIndex) => {
			segment.classList.toggle('is-active', segmentIndex === safeIndex);
		});
	};

	const syncThumbs = (slider, index) => {
		const subSlider = getSubSlider(slider);

		if (!subSlider) return;

		const thumbs = Array.from(
			subSlider.querySelectorAll(
				'.swiper-wrapper > .product__media-subitem.swiper-slide:not(.swiper-slide-duplicate)'
			)
		);

		thumbs.forEach((thumb, thumbIndex) => {
			thumb.classList.toggle('swiper-slide-thumb-active', thumbIndex === index);
		});

		if (subSlider.swiper && !subSlider.swiper.destroyed && typeof subSlider.swiper.slideTo === 'function') {
			subSlider.swiper.slideTo(index, 300, false);
		}
	};

	const syncAll = (slider) => {
		const index = getRealIndex(slider);

		ensureProgress(slider);
		setProgress(slider, index);
		syncThumbs(slider, index);
	};

	const forceHorizontal = (slider) => {
		const swiper = slider.swiper;

		slider.dataset.direction = 'horizontal';
		slider.dataset.direction_desc = 'horizontal';

		if (!swiper || swiper.destroyed) return;

		if (swiper.params) {
			swiper.params.direction = 'horizontal';
			swiper.params.allowTouchMove = true;
			swiper.params.simulateTouch = true;
			swiper.params.touchRatio = 1;
		}

		if (typeof swiper.changeDirection === 'function') {
			swiper.changeDirection('horizontal', false);
		}

		if (typeof swiper.update === 'function') {
			swiper.update();
		}
	};

	const goToIndex = (slider, index, speed = 300) => {
	const swiper = slider.swiper;
	const count = getSlideCount(slider);
	const safeIndex = ((index % count) + count) % count;

	if (!swiper || swiper.destroyed) return;

	forceHorizontal(slider);

	if (swiper.params && swiper.params.loop && typeof swiper.slideToLoop === 'function') {
		swiper.slideToLoop(safeIndex, speed, false);
	} else if (typeof swiper.slideTo === 'function') {
		swiper.slideTo(safeIndex, speed, false);
	}

	setProgress(slider, safeIndex);
	syncThumbs(slider, safeIndex);
};

	const goNext = (slider) => {
		const count = getSlideCount(slider);
		const currentIndex = getRealIndex(slider);

		if (count <= 1) return;

		goToIndex(slider, currentIndex + 1, 300);
	};

	const goPrev = (slider) => {
		const count = getSlideCount(slider);
		const currentIndex = getRealIndex(slider);

		if (count <= 1) return;

		goToIndex(slider, currentIndex - 1, 300);
	};

	const bindManualSwipe = (slider) => {
		if (slider.dataset.mainProductManualSwipeBound === 'true') return;

		let startX = 0;
		let startY = 0;
		let isDown = false;

		slider.addEventListener('pointerdown', (event) => {
			isDown = true;
			startX = event.clientX;
			startY = event.clientY;
		});

		slider.addEventListener('pointerup', (event) => {
			if (!isDown) return;

			isDown = false;

			const diffX = event.clientX - startX;
			const diffY = event.clientY - startY;

			if (Math.abs(diffX) < SWIPE_THRESHOLD) return;
			if (Math.abs(diffY) > Math.abs(diffX)) return;

			if (diffX < 0) {
				goNext(slider);
			} else {
				goPrev(slider);
			}
		});

		slider.addEventListener('pointercancel', () => {
			isDown = false;
		});

		slider.dataset.mainProductManualSwipeBound = 'true';
	};

	const bindSlider = (slider) => {
		if (!slider || slider.dataset.mainProductProgressBound === 'true') return;

		ensureProgress(slider);
		setProgress(slider, 0);

		if (slider.swiper && !slider.swiper.destroyed) {
			forceHorizontal(slider);
			syncAll(slider);

			slider.swiper.on('slideChange', () => {
				syncAll(slider);
			});

			slider.swiper.on('transitionEnd', () => {
				syncAll(slider);
			});
		}

		bindManualSwipe(slider);

		slider.dataset.mainProductProgressBound = 'true';
	};

	const init = () => {
		getSections().forEach((section) => {
			getMainSliders(section).forEach((slider) => {
				if (!slider.classList.contains('swiper')) return;

				bindSlider(slider);
			});
		});
	};

	const scheduleInit = () => {
		if (initFrame) {
			cancelAnimationFrame(initFrame);
		}

		initFrame = requestAnimationFrame(() => {
			initFrame = null;
			init();
		});
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => {
			scheduleInit();
			setTimeout(scheduleInit, 300);
			setTimeout(scheduleInit, 800);
			setTimeout(scheduleInit, 1400);
		});
	} else {
		scheduleInit();
		setTimeout(scheduleInit, 300);
		setTimeout(scheduleInit, 800);
		setTimeout(scheduleInit, 1400);
	}

	window.addEventListener('load', scheduleInit);
	document.addEventListener('shopify:section:load', scheduleInit);
	document.addEventListener('shopify:section:reorder', scheduleInit);

		const refreshMainProductSwipers = () => {
		document
			.querySelectorAll('.main-product-section .product__media-list[data-slider-type="main-product"]')
			.forEach((slider) => {
				if (!slider.swiper || slider.swiper.destroyed) return;

				if (slider.swiper.params) {
					slider.swiper.params.allowTouchMove = true;
					slider.swiper.params.simulateTouch = true;
					slider.swiper.params.touchRatio = 1;
				}

				slider.swiper.allowTouchMove = true;

				if (typeof slider.swiper.update === 'function') {
					slider.swiper.update();
				}
			});
	};

	window.addEventListener('load', () => {
		setTimeout(refreshMainProductSwipers, 100);
		setTimeout(refreshMainProductSwipers, 500);
	});

	window.addEventListener('resize', () => {
		setTimeout(refreshMainProductSwipers, 100);
	});

	window.addEventListener('orientationchange', () => {
		setTimeout(refreshMainProductSwipers, 300);
	});

	document.addEventListener('shopify:section:load', () => {
		setTimeout(refreshMainProductSwipers, 300);
	});
})();